import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, retry, switchMap } from 'rxjs/operators';
import { Cookie } from 'ng2-cookies';
import { UtilityService } from '@services/utility.service';
import { environment } from '@environments/environment';
import { SiteCookies, SiteText } from '@constants/global';
import { INewTokenResponse } from '@interfaces/common';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '@services/notification.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private utility: UtilityService, private auth: AuthService, private spinner: NgxSpinnerService, private notification: NotificationService) {}


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.spinner.show('chefLoader');
    return next.handle(request).pipe(
        retry(0),
        tap((evt: any) => {
            if (evt instanceof HttpResponse) {
              this.spinner.hide('chefLoader');
            }
        }),
        catchError(error => {
          this.spinner.hide('chefLoader');
          return this.errorHandle(request, next, error);
        })
    );
  }

  errorHandle(request: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse){
    if(error.status === 500 && error.error.message === 'Expired token'){ 
      return this.getNewToken(request,next, error);
    }else if(error.status === 401){
      this.notification.showNotification('error', SiteText.SESSION_ERROR);
      this.auth.redirectToLogin();
      return throwError(error.message);
    }else{
      return throwError(error);
    }
  }

  getNewToken(req: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse){
    const payload = {
      token: this.utility.getCookie(SiteCookies.REFRESHTOKEN)
    };
    return this.utility.sendRequest<INewTokenResponse>(environment.getNewToken, payload).pipe(
        switchMap((data: INewTokenResponse) => {
            if(data.response.code == '0000'){
              this.utility.setCookie(SiteCookies.ACCESSTOKEN, data.response.token);
              this.utility.setCookie(SiteCookies.REFRESHTOKEN, data.response.refresh_token);
              
              if(req.url.includes('logout')){ // for logout set the new refresh token in the payload
                req = req.clone({
                  setHeaders: {
                    "Authorization": 'Bearer ' + data.response.token
                  },
                  body: {
                    token: data.response.refresh_token
                  }
                });
              }else{
                req = req.clone({
                  setHeaders: {
                    "Authorization": 'Bearer ' + data.response.token
                  }
                });
              }
              return next.handle(req);
            }else{
              this.notification.showNotification('error', SiteText.SESSION_ERROR);
              this.auth.redirectToLogin();
              return throwError(error.message);
            }
        })
    );
  }

}
